interface Props {
    size?: number;
}

export default function IdVerificationIcon({ size = 24 }: Props) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="3"
                y="6"
                width="18"
                height="12"
                rx="2"
                ry="2"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
            />
            <circle cx="9" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
            <path
                d="M6.8 15.5C7.4 14.5 8.2 14 9 14C9.8 14 10.6 14.5 11.2 15.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M15 11L16.5 13L19 9.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
